// extracted by mini-css-extract-plugin
export default {"component":"NIwT4u2d","label":"KZG7PmtA","input":"MYwCwj3m","preventLabelAnimation":"l6cN4ncI","input-not-empty":"W7Qncwya"};